import { BotMessageSquareIcon } from 'lucide-react';
import { HStack, Pressable } from 'native-base';
import { useTranslation } from 'react-i18next';

import { Text, ThemeColors } from '@pimm/base';

export type ContactSupportLinkProps = {
  message?: string;
  onPress?: () => void;
};

export const ContactSupportLink = ({ message, onPress }: ContactSupportLinkProps) => {
  const { t } = useTranslation();

  return (
    <Pressable onPress={onPress}>
      <HStack alignItems="center" space={1.5}>
        <BotMessageSquareIcon size={20} color={ThemeColors.blue[500]} />
        <Text size="md" fontWeight={500} color="blue.500">
          {message ?? t('store_settings:need_to_update_caption')}
        </Text>
      </HStack>
    </Pressable>
  );
};
